
export const baseURL = 'https://alkiraapi.alkira.ma/';

export const environment = {
  production: false,
  SOCKET_ENDPOINT: 'http://localhost:3000'
};

export const timeoutTime = 45000;
